import React from "react";

interface VectorUpProps {
  className?: string;
}

function VectorUp({ className }: VectorUpProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      width="100%"
      height="100%"
      className={className}
    >
      <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z" />
    </svg>
  );
}

export default VectorUp;
